// Responsive 3:2 WebP photo with the site's shared frame: 6px radius, warm-gray border, restrained shadow.
// Sources are served as /assets/photos/<base>-{550,825,1100}.webp (see /public/assets/photos/CREDITS.md).
export const Photo = ({ photo, sizes = "(min-width: 1024px) 550px, 100vw", eager = false, className = "", testId }) => (
  <figure data-testid={testId} className={`group overflow-hidden rounded-[6px] border border-[#D8D1C5] bg-cream-ivory ${className}`}
    style={{ boxShadow: "0 6px 20px rgba(15, 23, 42, 0.06)" }}>
    <img
      src={`${photo.base}-825.webp`}
      srcSet={`${photo.base}-550.webp 550w, ${photo.base}-825.webp 825w, ${photo.base}-1100.webp 1100w`}
      sizes={sizes}
      width={550}
      height={367}
      alt={photo.alt}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      className="block w-full h-auto motion-safe:group-hover:scale-[1.03] transition-transform duration-700 ease-out"
    />
  </figure>
);
